import React from "react";
import { Image } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboard,
  faUserGroup,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import avatar from "../../assets/avatar.png";

/** Circular avatar + name, used by every people table. */
export const personNameColumn = (t, { label = "Name" } = {}) => ({
  key: "name",
  label,
  skeleton: <Skeleton width={160} />,
  render: (u) => (
    <div className="d-flex align-items-center gap-2">
      <Image
        src={u?.avatar?.imageUrl?.url || u?.imageUrl?.url || avatar}
        alt=""
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          objectFit: "cover",
          flex: "0 0 36px",
        }}
      />
      <span style={{ color: "#303972", fontWeight: 700, fontSize: "14px" }}>
        {u?.fullName || "-"}
      </span>
    </div>
  ),
});

export const emailColumn = (t) => ({
  key: "email",
  label: "Email",
  skeleton: <Skeleton width={180} />,
  render: (u) =>
    u?.email ? (
      <span
        className="d-inline-flex align-items-center gap-1 text-muted"
        style={{ fontSize: "13px" }}
      >
        <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: "12px" }} />
        {u.email}
      </span>
    ) : (
      <span className="text-muted">-</span>
    ),
});

export const phoneColumn = (t) => ({
  key: "phone",
  label: "Phone",
  skeleton: <Skeleton width={110} />,
  render: (u) => (
    <span className="text-muted" style={{ fontSize: "13px" }}>
      {u?.phone || u?.number || "-"}
    </span>
  ),
});

export const statusColumn = (t) => ({
  key: "status",
  label: "Status",
  skeleton: <Skeleton width={70} />,
  render: (u) => {
    const active = u?.status === "active";
    return (
      <span
        style={{
          display: "inline-block",
          padding: "3px 12px",
          borderRadius: "30px",
          fontSize: "12px",
          fontWeight: 600,
          color: "#fff",
          background: active ? "#1B9C63" : "#B0B0B0",
        }}
      >
        {active ? t("Active") : t("Inactive")}
      </span>
    );
  },
});

/** Dark icon circle + title, used by every class/group table. */
export const entityTitleColumn = (
  t,
  { isGroup = false, label = "Name" } = {}
) => ({
  key: "title",
  label,
  className: "py-3 ps-3",
  thClassName: "py-3 ps-3 fw-semibold",
  skeleton: <Skeleton width={180} />,
  render: (item) => (
    <div className="d-flex align-items-center gap-2">
      <div
        className="d-flex align-items-center justify-content-center bg-dark flex-shrink-0"
        style={{ width: "36px", height: "36px", borderRadius: "60px" }}
      >
        <FontAwesomeIcon
          icon={isGroup ? faUserGroup : faChalkboard}
          style={{ fontSize: "16px", color: "white" }}
        />
      </div>
      <span className="fw-bold" style={{ fontSize: "14px", color: "#303972" }}>
        {item?.title || "-"}
      </span>
    </div>
  ),
});

/** Student count for a class/group row. */
export const memberCountColumn = (t) => ({
  key: "members",
  label: "Students",
  skeleton: <Skeleton width={40} />,
  render: (item) => (
    <span
      className="d-inline-flex align-items-center gap-1"
      style={{ fontSize: "14px" }}
    >
      <FontAwesomeIcon
        icon={faUserGroup}
        className="text-muted"
        style={{ fontSize: "12px" }}
      />
      {item?.studentCount ?? item?.students?.length ?? 0}
    </span>
  ),
});
